module.exports = __webpack_public_path__ + "static/media/mall-discount-bg-green.8e88fd3f.svg";